<template>
  <div id="app" :style="{'display':display}">

    <header class="container header">
      <div class="d-flex justify-content-between">
        <img src="assets/img/webpay_blue.svg" alt="logo" class="headLogo">
        <nav class="d-flex align-items-center header__lang-menu">
          <a href=""
             class="change_language"
             @click="changeLanguage"
             :style="language == 'russian' ? {'color': siteBrandColor} : {'color': siteBrandColor + 77}"
             data-current="russian">RU</a>
          <a href="" class="change_language"
             @click="changeLanguage"
             :style="language == 'english' ? {'color': siteBrandColor} : {'color': siteBrandColor + 77}"
             data-current="english">EN</a>
        </nav>
      </div>
    </header>

    <!--PAYMENT FORM START-->
    <section class="container content qr">
      <div class="twoBlocks">
        <div class="content__block-left">
          <div class="qrBlock">
            <ErrorPage
                v-if="merchantInfoLoaded === false"
                :error-message="locale[language][errorType]"
            ></ErrorPage>
            <div
                v-if="merchantInfoLoaded"
                class="main_payment_info"
            >
              <MerchantInfo
                  v-if="merchantInfoLoaded"
                  :merchant-info="merchantInfo"
              ></MerchantInfo>
              <Form
                  v-if="merchantInfoLoaded"
                  @submitting="submitting"
                  :test="getTestParam()"
                  :siteBrandColor="siteBrandColor"
                  :apiPath="apiPath"
                  :billingId="getBillingId()"
                  :language="language"
                  :merchant-info="merchantInfo"
              ></Form>
            </div>
          </div>
        </div>
      </div>

      <!--PAYMENT FORM END-->
      <Footer :site-brand-color="siteBrandColor"
              :language="language"
      ></Footer>
    </section>
    <div class="preload-wrap"
         :style="{display: preLoader}"
    >
      <div>
        <div class="logo-bg1"><img src="assets/img/wp1.png" alt=""></div>
        <div class="logo-bg2"><img src="assets/img/wp2.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>

import MerchantInfo from "./components/MerchantInfo";
import Form from "./components/Form";
import Footer from "./components/Footer";
import ErrorPage from "./components/ErrorPage";

export default {
  name: 'App',
  data: function () {
    return {
      locale: {
        'russian': {
          serverError: 'Серверная ошибка. Пожалуйста, обратитесь в тех поддержку',
          badRequestError: 'Неверный запрос'
        },
        'english': {
          serverError: 'Server error. Please contact technical support',
          badRequestError: 'Bad request'
        }
      },
      apiPath: process.env.VUE_APP_API_URL,
      display: 'none', // css display
      preLoader: 'none', // css display
      language: 'russian',
      siteBrandColor: '#2C387A',
      merchantInfoLoaded: false,
      errorType: 'serverError',
      merchantInfo: {
        siteName: "",
        siteLegalPerson: "",
        siteZip: "",
        countryName: "",
        siteCity: "",
        siteAddress: "",
        sitePhone: "",
        siteEmail: "",
        foreignCurrency: "",
        qrPageOptions: {},
        productPageOptions: {},
      },
    }
  },
  methods: {
    submitting: function (e) {
      this.preLoader = e == true ? 'block' : 'none';
    },
    changeLanguage: function (e) {
      e.preventDefault();
      this.language = e.target.getAttribute('data-current');
    },
    getBillingId: function () {
      return this.getUrlParams()['billing_id'];
    },
    getTestParam: function () {
      let test = this.getUrlParams()['test'];
      return test ? test : '0';
    },
    getUrlParams: function () {
      let vars = {};
      let urls = window.location.href.split('?');
      let uri = urls[1] ? urls[1] : '';

      if (uri.match('billing_id') !== null) {
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
          vars[key] = value.replace(/#/, '');
        });
      } else {
        atob(window.location.href.split('?')[1]).replace(/([^=&]+)=([^&]*)/gi, function (m, key, value) {
          vars[key] = value.replace(/#/, '');
        });
      }

      return vars;
    },
    parseMerchantInfo: function (body) {
      if (body.setup.siteBrandColor) {
        this.siteBrandColor = '#' + body.setup.siteBrandColor;
      }
      this.merchantInfo.siteName = body.setup.siteName;
      this.merchantInfo.siteLegalPerson = body.setup.siteLegalPerson;
      this.merchantInfo.siteZip = body.setup.siteZip;
      this.merchantInfo.countryName = body.setup.countryName;
      this.merchantInfo.siteCity = body.setup.siteCity;
      this.merchantInfo.siteAddress = body.setup.siteAddress1;
      this.merchantInfo.sitePhone = body.setup.sitePhone;
      this.merchantInfo.siteEmail = body.setup.siteEmail;
      this.merchantInfo.foreignCurrency = body.foreignCurrency;
      this.merchantInfo.currencyList = body.currencyList;
      this.merchantInfo.qrPageOptions = body.setup.qrPageOptions;
      this.merchantInfo.productPageOptions = body.setup.productPageOptions;
    },
    getMerchantInfo: function () {
      return this.$http
          .get(`${this.apiPath}/billing/get/${this.getBillingId()}`)
          .then(response => {
            return response.data.body;
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.errorType = 'serverError';
            } else {
              this.errorType = 'badRequestError';
            }
            throw new Error(error);
          });
    }
  },
  created() {
    this.getMerchantInfo()
        .then(body => {
          this.display = 'block';
          this.parseMerchantInfo(body);
          this.merchantInfoLoaded = true;
        })
        .catch(() => {
          this.display = 'block';
        })
    ;
  },
  components: {
    ErrorPage,
    MerchantInfo,
    Form,
    Footer,
  },
}
</script>



